var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-complain" },
    [
      _c(
        "yxt-dialog",
        {
          ref: "drawer",
          attrs: {
            "custom-class": _vm.isIe ? "yxtbiz-complain__ie-style" : "",
            title: _vm.$t("pc_biz_complain_title"),
            visible: _vm.visible,
            width: "640px",
            "append-to-body": true,
            "before-close": _vm.cancel,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showSuccess,
                  expression: "showSuccess",
                },
              ],
              staticClass: "yxtbiz-complain__success",
            },
            [
              _c("img", {
                attrs: {
                  src:
                    _vm.$staticBaseUrl + "assets/d6a49468/58ae9ff1/8af4c7.png",
                  alt: "",
                },
              }),
              _c("h3", [_vm._v(_vm._s(_vm.$t("pc_biz_complain_success")))]),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.showSuccess,
                  expression: "!showSuccess",
                },
              ],
              staticClass: "yxtbiz-complain__content",
            },
            [
              _c(
                "yxt-form",
                {
                  ref: "complainForm",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "100px",
                    "is-need-require": "",
                  },
                },
                [
                  _c(
                    "yxt-form-item",
                    {
                      attrs: {
                        label: _vm.$t("pc_biz_complain_name"),
                        prop: "targetName",
                      },
                    },
                    [
                      _vm.isContent
                        ? _c(
                            "div",
                            [
                              _vm.$slots.targetName
                                ? _vm._t("targetName")
                                : _vm._e(),
                              _c("span", [
                                _vm._v(_vm._s(_vm.target.targetName)),
                              ]),
                            ],
                            2
                          )
                        : _c("div", [
                            _c("div", { staticClass: "notes" }, [
                              _c(
                                "div",
                                { staticClass: "info" },
                                [
                                  _vm._v("【"),
                                  _vm.$slots.targetInfo
                                    ? _vm._t("targetInfo")
                                    : _c("span", [
                                        _vm._v(_vm._s(_vm.target.targetInfo)),
                                      ]),
                                  _vm._v("】"),
                                ],
                                2
                              ),
                              _vm.target.audioUrl !== ""
                                ? _c("div", [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "el-audio-tag hand",
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.getMusic(
                                              _vm.target.audioUrl,
                                              _vm.target.targetId
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "mr10 editsrc",
                                          attrs: {
                                            width: "20",
                                            src:
                                              _vm.isMusicActive ===
                                              _vm.target.targetId
                                                ? _vm.$staticBaseUrl +
                                                  "assets/d6a49468/9caf5d97/8e82aa.gif"
                                                : _vm.$staticBaseUrl +
                                                  "assets/d6a49468/409d62ad/01cd48.png",
                                          },
                                        }),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.target.audioLength) +
                                              "''"
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ])
                                : _c(
                                    "div",
                                    { staticClass: "clamp2" },
                                    [
                                      _vm.$slots.targetName
                                        ? _vm._t("targetName")
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.target.targetName)
                                            ),
                                          ]),
                                    ],
                                    2
                                  ),
                            ]),
                          ]),
                    ]
                  ),
                  _c(
                    "yxt-form-item",
                    {
                      attrs: {
                        label: _vm.$t("pc_biz_complain_category"),
                        prop: "category",
                      },
                    },
                    [
                      _c(
                        "yxt-radio-group",
                        {
                          on: { change: _vm.handleChange },
                          model: {
                            value: _vm.form.category,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "category", $$v)
                            },
                            expression: "form.category",
                          },
                        },
                        _vm._l(_vm.categories, function (catagory) {
                          return _c(
                            "yxt-radio",
                            {
                              key: catagory.value,
                              attrs: { label: catagory.value },
                            },
                            [_vm._v(_vm._s(catagory.name))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "yxt-form-item",
                    {
                      attrs: {
                        label: _vm.$t("pc_biz_complain_content"),
                        prop: "content",
                      },
                    },
                    [
                      _c("yxt-input", {
                        attrs: {
                          placeholder: _vm.$t("pc_biz_complain_placeholder"),
                        },
                        model: {
                          value: _vm.form.content,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "content", $$v)
                          },
                          expression: "form.content",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "yxt-form-item",
                    {
                      attrs: {
                        label: _vm.$t("pc_biz_complain_desp"),
                        prop: "description",
                      },
                    },
                    [
                      _c("yxt-input", {
                        attrs: {
                          type: "textarea",
                          rows: "6",
                          maxlength: "200",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.form.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "description", $$v)
                          },
                          expression: "form.description",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "yxt-form-item",
                    {
                      staticClass: "yxtbiz-complain__imgupload-item",
                      attrs: { prop: "imgUrl" },
                    },
                    [
                      _c("template", { slot: "label" }, [
                        _c("div", [
                          _vm._v(_vm._s(_vm.$t("pc_biz_complain_ticket"))),
                        ]),
                        _c("div", { staticClass: "color-gray-7" }, [
                          _vm._v(_vm._s(_vm.form.imgUrl.length) + "/5"),
                        ]),
                      ]),
                      _vm.visible
                        ? _c("upload-pic", {
                            attrs: { "logo-url": _vm.form.imgUrl },
                            on: {
                              "update:logoUrl": function ($event) {
                                return _vm.$set(_vm.form, "imgUrl", $event)
                              },
                              "update:logo-url": function ($event) {
                                return _vm.$set(_vm.form, "imgUrl", $event)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.showSuccess,
                  expression: "!showSuccess",
                },
              ],
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("yxt-button", { on: { click: _vm.cancel } }, [
                _vm._v(_vm._s(_vm.$t("pc_biz_complain_cancel"))),
              ]),
              _c(
                "yxt-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.submit },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.loading
                        ? _vm.$t("pc_biz_complain_submitting")
                        : _vm.$t("pc_biz_complain_submit")
                    )
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }